import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

export const firebaseConfig = {
  apiKey: "AIzaSyABHfuhzj5SOKg-zPOi7fzwPGu_pjnhbsE",
  authDomain: "invoice-billing-web-app.firebaseapp.com",
  databaseURL: "https://invoice-billing-web-app-default-rtdb.firebaseio.com",
  projectId: "invoice-billing-web-app",
  storageBucket: "invoice-billing-web-app.firebasestorage.app",
  messagingSenderId: "888082183464",
  appId: "1:888082183464:web:8b14300691b4be56e98c1d",
  measurementId: "G-3MJ65MMKC0"
};

export const app  = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const rtdb = getDatabase(app);

